var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myDiv"},[_c('header',{staticClass:"test-title"},[_vm._v("测试使用")]),(_vm.loading)?_c('div',{staticClass:"test-title"},[_vm._v("加载中.....")]):_vm._e(),_c('div',{attrs:{"id":"paypal-button-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }